import { FC, useMemo, useState } from 'react'
import { Minus, Plus } from 'lucide-react'
import { getContrastColor, getHoverColor } from '@/js/helper/color.ts'
import { useAtomValue } from 'jotai'
import { mapDataAtom } from '@/js/editor/state/mapAtoms.ts'

export type TagProps = {
    title: string
    icon?: string
    action?: () => void
    className?: string
}

export const Tag: FC<TagProps> = ({ title, action, icon, className }) => {
    const { colors } = useAtomValue(mapDataAtom)
    const color = colors.primary ?? 'var(--color-mm-blue)'
    const [isHovered, setIsHovered] = useState(false)

    const textColor = useMemo(() => getContrastColor(color), [color])
    const hoverColor = useMemo(() => getHoverColor(color, 0.4), [color])

    return (
        <div
            className={`flex flex-row items-center cursor-pointer rounded-full space-x-2 py-1 w-fit h-fit transition-all duration-300 ${isHovered ? 'px-4 shadow-md' : 'px-3 shadow-sm'} ${className}`}
            style={{ backgroundColor: isHovered ? hoverColor : color, color: textColor }}
            onClick={action}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <span className={'text-xs whitespace-nowrap'}>{title}</span>
            {isHovered && icon === 'minus' && (
                <Minus size={16} color={textColor} className={'transition-opacity duration-500 opacity-100'} />
            )}
            {isHovered && icon === 'plus' && (
                <Plus size={16} color={textColor} className={'transition-opacity duration-500 opacity-100'} />
            )}
        </div>
    )
}
